import {AnyColor} from '@components/common/base/design-system'
import {ChatSystemMessageType} from './types'

export const getBackground = (type: ChatSystemMessageType): string => {
  switch (type) {
    case 'error':
      return 'bg-error-l100'
    case 'info':
      return 'bg-interactive-l100'
    case 'success':
      return 'bg-sticker-green'
    default:
      throw new Error(`Unknown type: ${type}`)
  }
}

export const getColor = (type: ChatSystemMessageType): string => {
  switch (type) {
    case 'error':
      return 'text-error'
    case 'info':
      return 'text-interactive'
    case 'success':
      return 'text-secondary'
    default:
      throw new Error(`Unknown type: ${type}`)
  }
}

export const getIconColor = (type: ChatSystemMessageType): AnyColor => {
  switch (type) {
    case 'error':
      return 'error'
    case 'info':
      return 'interactive'
    case 'success':
      return 'secondary'
    default:
      throw new Error(`Unknown type: ${type}`)
  }
}
